import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { UserDetailHeader } from '~/features/UserDetailHeader';
import { UserDetailProfile } from '~/features/UserDetailProfile';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 利用者詳細 Screen
 */
export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const userId = Number.parseInt(id, 10);
  if (Number.isNaN(userId)) {
    return <Navigate to={ROUTES.USERS} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <UserDetailHeader userId={userId} />
          <main className={styles.body}>
            <UserDetailProfile userId={userId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
